import React from 'react';
import PropTypes from 'prop-types';
import './Button.less'; // 我們將創建一個 LESS 文件來為這個元件添加樣式

const Button = ({ text, link }) => {
  return (
    <a href={link} className="custom-button">
      {text}
    </a>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default Button;